import { AuthPasskeyLayout } from 'Views/Authentication/Layout/AuthnPasskeyLayout';
import {
  IdentityProviderLayout,
} from 'Views/Authentication/Layout/IdentityProviderLayout/IdentityProviderLayout';
import {
  RoleSelectionLayout,
} from 'Views/Authentication/Layout/RoleSelectionLayout/RoleSelectionLayout';
import { AuthnMfaRequiredResetStepLayout } from './AuthnMfaRequiredResetStepLayout';
import { AuthLoginEmailLayout } from './AuthLoginEmailLayout';
import { AuthLoginPasswordLayout } from './AuthLoginPasswordLayout';
import { AuthMultiFactorSMSLayout } from './AuthMultiFactorSMSLayout';
import { AuthMultiFactorTOTPLayout } from './AuthMultiFactorTOTPLayout';
import { AuthPasswordResetLayout } from './AuthPasswordResetLayout';
import { DefaultLayout } from './DefaultLayout';
import { UserLayout } from './UserLayout';
import { AuthnMfaResetLayout } from './AuthnMfaResetLayout';
import { AuthnMfaResetVerificationLayout } from './AuthnMfaResetVerificationLayout';

const resourceToComponentMap = {
  AuthLoginEmail: AuthLoginEmailLayout,
  AuthLoginPassword: AuthLoginPasswordLayout,
  AuthnPasskey: AuthPasskeyLayout,
  AuthLoginMultiFactor: AuthMultiFactorSMSLayout,
  AuthTotp: AuthMultiFactorTOTPLayout,
  AuthPasskey: AuthPasskeyLayout,
  AuthPasswordResetEmail: AuthPasswordResetLayout,
  AuthPasswordResetEmailConfirmation: AuthPasswordResetLayout,
  AuthPasswordResetTotp: AuthMultiFactorTOTPLayout,
  AuthPasswordResetMultiFactor: AuthMultiFactorSMSLayout,
  AuthPasswordReset: AuthPasswordResetLayout,
  AuthnMfaResetVerification: AuthnMfaResetVerificationLayout,
  AuthnMfaReset: AuthnMfaResetLayout,
  AuthnMfaRequiredResetStep: AuthnMfaRequiredResetStepLayout,
  user: UserLayout,
  IdentityProvider: IdentityProviderLayout,
  RoleSelectionPage: RoleSelectionLayout,
};

export const getLayout = (resource) => {
  const Component = resourceToComponentMap[resource.type()];

  return Component || DefaultLayout;
};
